import { object, string, ObjectSchema, StringSchema } from 'yup';
import { LanguageService } from '@bigcommerce/checkout-sdk';
import { FormField } from '@bigcommerce/checkout-sdk';

type TranslateValidationErrorFunction = ((
  validationType: 'max' | 'min' | 'required' | 'invalid',
  field: {
      name: string;
      label: string;
      min?: number;
      max?: number;
  }
) => string | undefined);

export interface FormFieldsValidationSchemaOptions {
  formFields: FormField[];
  translate?: TranslateValidationErrorFunction;
  language?: any
}
interface FormFieldValues {
  [key: string]: string | { [id: string]: any };
}

const WHITELIST_REGEXP = /^[^<>]*$/;

const getB3FormFieldsValidationSchema = ({formFields, translate = () => undefined}: FormFieldsValidationSchemaOptions): ObjectSchema<FormFieldValues> => {
  return object({
      ...formFields
          .reduce((schema, { name, required, label }) => {
              schema[name] = string();

              if (required) {
                  schema[name] = schema[name].required(translate('required', { label, name }));
              }

              schema[name] = schema[name].matches(
                  WHITELIST_REGEXP,
                  translate('invalid', { name, label })
              );

              return schema;
          },
          {} as { [key: string]: StringSchema }
      ),
  })
}

export const getTranslateAddressError = (language?: LanguageService): TranslateValidationErrorFunction => {
  return (type, { label, min, max }) => {
      if (!language) {
          return;
      }

      if (type === 'required') {
          return language.translate(`address.custom_required_error`, { label });
      }

      if (type === 'max' && max) {
          return language.translate(`address.custom_max_error`, { label, max });
      }

      if (type === 'min' && min) {
          return language.translate(`address.custom_max_error`, { label, min });
      }

      if (type === 'invalid') {
          return language.translate(`address.invalid_characters_error`, { label });
      }

      return;
  };
}


export { 
  getB3FormFieldsValidationSchema,
}